export default {
  errorLabel: {
    color: 'red',
    marginBottom: 10,
    display: 'block',
  },
};


// WEBPACK FOOTER //
// ./src/components/forms/collaborator-form/CollaboratorForm.styles.js